import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home.vue'
import CreateContract from '@/pages/CreateContract.vue'
import Docs from '@/pages/Docs.vue'
import MyContracts from '@/pages/MyContracts.vue'
import MyContractsNewUser from '@/pages/MyContracts.vue'
import MyUsers from '@/pages/MyUsers.vue'
import ContractTemplates from '@/pages/ContractTemplates.vue'
import ContractDetail from '@/pages/ContractDetails.vue'
import ContractTemplateDetail from '@/pages/ContractTemplateDetail.vue'
import ContractBuilder from '@/pages/ContractBuilder.vue'

// Onboarding V2
import PreContractTemplates from '@/pages/OnboardingV2/ContractTemplates.vue'
import PreContractTemplateDetail from '@/pages/OnboardingV2/ContractTemplateDetail.vue'

import SignIn from '@/pages/auth/SignIn.vue'
import SignUp from '@/pages/auth/SignUp.vue'
import SignOut from '@/pages/auth/SignOut.vue'
import ConfirmSignUp from '@/pages/auth/ConfirmSignUp.vue'
import PasswordReset from '@/pages/auth/PasswordReset.vue'
import ChangePassword from '@/pages/auth/ChangePassword.vue'
import ConfirmPasswordReset from '@/pages/auth/ConfirmPasswordReset.vue'
import Terms from '@/pages/terms/terms.vue'


import Billing from '@/pages/payment/billing.vue'
import Checkout from '@/pages/payment/checkout.vue'
import CheckoutVip from '@/pages/payment/checkoutVip.vue'
import FailCheckout from '@/pages/payment/fail.vue'
import SuccessCheckout from '@/pages/payment/success.vue'
import BillingInfo from '@/pages/payment/billingInfo.vue'
import BillingInfoVip from '@/pages/payment/billingInfoVip.vue'

// SmartCheck
import SmartcheckDashboard from '@/pages/smartcheck/dashboard.vue'

import store from '@/store'

Vue.use(Router)

const routes = [
    {
        path: '/', name: 'home', component: MyContracts, meta: { title: 'Home', auth: true }
    },
    {
        path: '/terms', name: 'terms', component: Terms, meta: { title: 'Smartpress Terms' }
    },
    {
        path: '/createContract', name: 'createContract', component: CreateContract, meta: { title: 'Smartpress', auth: true }
    },
    {
        path: '/docs', name: 'docs', component: Docs, meta: { title: 'Docs', auth: true }
    },
    {
        path: '/p/docs', name: 'docs', component: Docs, meta: { title: 'Docs', auth: false }
    },    
    {
        path: '/myContracts/:incomingUserType', name: 'myContractsNewUser', component: MyContractsNewUser, meta: { title: 'Contracts', auth: true }
    },
    {
        path: '/myContracts', name: 'myContracts', component: MyContracts, meta: { title: 'Contracts', auth: true }
    },
    {
        path: '/myUsers', name: 'myUsers', component: MyUsers, meta: { title: 'Users', auth: true }
    },


    // Original login templates
    {
        path: '/contractTemplates', name: 'contractTemplates', component: ContractTemplates, meta: { title: 'Temaplates', auth: true }
    },
    {
        path: '/contractTemplate/:contractType', name: 'contractTemplate', component: ContractTemplateDetail, meta: { title: 'Template', auth: true }
    },
    {
        path: '/contractDetail/:contractType', name: 'contractDetail', component: ContractDetail, meta: { title: 'Details', auth: true }
    },



    // Pre login contract templates
    {
        path: '/pre/contractTemplates', name: 'preContractTemplates', component: PreContractTemplates, meta: { title: 'Temaplates', auth: false }
    },
    {
        path: '/pre/contractTemplate/:contractType', name: 'preContractTemplate', component: PreContractTemplateDetail, meta: { title: 'Template', auth: false }
    },


    // 
    {
        path: '/databaseBuilder', name: 'databaseBuilder', component: ContractBuilder, meta: { title: 'DB builder', auth: true }
    },
    {
        path: '/signIn', name: 'signIn', component: SignIn, meta: { title: 'Sign In', auth: false }
    },
    {
        path: '/signIn/:incomingUserType', name: 'signIn', component: SignIn, meta: { title: 'Sign In', auth: false }
    },
    {
        path: '/signUp/:incomingUserType', name: 'signUp', component: SignUp, meta: { title: 'Sign Up', auth: false }
    },
    {
        path: '/confirmSignUp/:incomingUserType', name: 'confirmSignUp', component: ConfirmSignUp, meta: { title: 'Confirm SignUp', auth: false }
    },
     {
        path: '/signOut', name: 'signOut', component: SignOut, meta: { title: 'Sign Out', auth: true }
    },
    {
        path: '/changePassword', name: 'changePassword', component: ChangePassword, meta: { title: 'Change Password', auth: true }
    },
    {
        path: '/passwordReset', name: 'passwordReset', component: PasswordReset, meta: { title: 'Password Reset', auth: false }
    },
    {
        path: '/confirmPasswordReset', name: 'confirmPasswordReset', component: ConfirmPasswordReset, meta: { title: 'Confirm Password Reset', auth: false }
    },
    {
        path: '/Billing', name: 'Billing', component: Billing, meta: { title: 'Billing', auth: true }
    },
    {
        path: '/subscriptionPayment', name: 'subscriptionPayment', component: Checkout, meta: { title: 'Subcription payment', auth: true }
    },
    {
        path: '/subscriptionPaymentVip', name: 'subscriptionPaymentVip', component: CheckoutVip, meta: { title: 'Subcription payment', auth: true }
    },
    {
        path: '/paymentSuccess/:session_id', name: 'paymentSuccess', component: SuccessCheckout, meta: { title: 'Successful payment', auth: true }
    },
    {
        path: '/paymentFail', name: 'paymentFail', component: FailCheckout, meta: { title: 'Payment declined', auth: true }
    },
    {
        path: '/billingInfoVip', name: 'billingInfo', component: BillingInfoVip, meta: { title: 'Billing info', auth: true }
    },

    // smartcheck
    {
        path: '/smartcheck', name: 'smartcheck', component: SmartcheckDashboard, meta: { title: 'SmartCheck', auth: true }
    },
    {
        path: '/smartcheck/documents', name: 'documents', component: SmartcheckDashboard, meta: { title: 'SmartCheck', auth: true }
    },
    
]



const router = new Router({ mode: "history", routes })

// this routine will ensure that any pages marked as `auth` in the `meta` section are
// protected from access by unauthenticated users.
router.beforeEach((to, from, next) => {
    // Use the page's router title to name the page
    if (to.meta && to.meta.title) {
        document.title = to.meta.title
    }

    // is there a meta and auth attribute?
    if (to.meta && to.meta.auth !== undefined) {

        // if the page requires auth
        if (to.meta.auth) {
            // and we are authenticated?
            if (store.getters['auth/isAuthenticated']) {
                next() // route normally
                return
            }
            // otherwise off to the sign in page
            router.push({name: 'signUp', params: { incomingUserType: 'contract' }})
            return
        }
        // otherwise are we already authenticated?
        if (store.getters['auth/isAuthenticated']) {
            // yes we are, so off to dashboard

          
            router.push({name: 'myContracts'})
            return
        }
        next() // route normally
        return
    }
    next() // route normally
    return
})

export default router